import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";

//import data from '../../../datanew/Australia/data/opsView.json';

const TopHardwareManufacturer = (props) => {

    const [onLoading, setOnLoading] = useState(false)

    const [screenWidth, setScreenWidth] = useState(1000);

    const data = props.data;

  useEffect(() => {
      setScreenWidth (window.innerWidth - ((window.innerWidth * 25)/100))
  }, []);

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        colors: ['#333']
      }
    },
    xaxis: {
      categories: data.charts.topHardwareManufacturer.map(item => item.name)
    },
    colors: ['#5dbc53', '#d76358', '#4e86e4', '#f0ad4e', '#9370db'],
    title: {
      text: '',
      align: 'center',
      style: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#333'
      }
    },
    grid: {
      borderColor: '#f1f1f1'
    }
  };

  const series = [{
    name: 'Assets',
    data: data.charts.topHardwareManufacturer.map(item => item.assets)
  }];

   

    return (
        <div style={{
            width: '32%', marginLeft: 0, display: 'flex', 
            flexDirection: 'column', height: 450,
            marginTop: '2%', background: 'linear-gradient(135deg, #161c2a, #1a2130)', padding: 20, borderRadius: 15
        }}>



            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginTop: 10 }}>


            <div style={{ height: 60, }}>


                    <h6 style={{ color: '#fff', textAlign: 'left' }}>
                    Top Hardware Manufacturer</h6>
                    <hr />

            </div>


                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height:300 }}>
                         
                    <ReactApexChart options={options} series={series} 
                    type="bar" height={360} width={screenWidth * 0.3}/>


                    </div>
                </div>
            


        </div>
    );
};

export default TopHardwareManufacturer;